import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { QuotesHttpService } from './quotes-http.service';
import notify from 'devextreme/ui/notify';
import { QuotesPDFModalComponent } from './quotes-pdf-modal/quotes-pdf-modal.component';
import { QuotesModalComponent } from './quotes-modal/quotes-modal.component';
import { QuoteStatusesLabels } from './quotes.constants';
import { IQuote } from './quotes.interface';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { AlertService } from '../../../shared/services/alert.service';
import { SettingsService } from '../../settings-page/settings/settings.service';
import { SETTINGS } from '../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { TaskModalComponent } from '../../tasks-page/tasks/task-modal/task-modal.component';

let self: any;

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {
      status: 'ACTIVE'
    },
    sort: '-createdAt',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  quotes: any;
  curr!: string;
  quoteStatuses:any = QuoteStatusesLabels;
  quoteStatusesKeys = Object.keys(QuoteStatusesLabels);
  quoteStatusColors: any = {};
  querySubscription!: Subscription;

  constructor(
    private _QuotesService: QuotesHttpService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
    private alertService: AlertService,
    private _SettingsService: SettingsService,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.getQuotesColors()
    this.getQuotes(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getQuotes(true);
      }
    }, 1000);
  }

  getQuotes(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.quotes = [];
      this.clearSelection();
    }
    this._QuotesService.getQuotes(this.filter).subscribe((quotes: any) => {
      this.quotes = _.concat(this.quotes, quotes);
      this.thereAreMore = quotes.length >= self.filter.limit;
      this.loading = false;
    })
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewQuotesModal());
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      self.filter.skip += self.filter.limit;
      this.getQuotes();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  async getQuotesColors() {
    this.quoteStatusColors = { DEFAULT: 'white', ACCEPTED: '#27b3a5', SCHEDULED: '#337AB7', INVOICED: '#337AB7' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.quoteStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.quoteStatusColors.CANCELLED = color });
  }

  openNewQuotesModal() {
    this.openQuotesModal({});
  }

  openQuotesModal(quote: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(QuotesModalComponent, config);
    self.dialogRef.componentInstance.quote = quote;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getQuotes(true);
    });
  }

  openQuote(quote: any) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(QuotesPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = quote;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
      if (result) this.getQuotes(true);
    });
  }

  openDeleteQuoteConfirm(quote: IQuote, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Presupuesto",
      message: "¿Esta seguro que desea eliminar el presupuesto #" + quote.number + "?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._QuotesService.deleteQuote(quote, hardDelete).subscribe(() => {
            if (hardDelete) this.getQuotes(true);
            else {
              quote.isDeleted = true;
              quote.status = 'CANCELLED';
              this.getQuotes(true);
            }
          })
        }
      });
  }

  openRestoreQuoteConfirm(quote: IQuote) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Presupuesto",
      message: "¿Esta seguro que desea restaurar el presupuesto #" + quote.number + "?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._QuotesService.restoreQuote(quote).subscribe(() => {
            quote.isDeleted = false;
            quote.status = 'QUOTED';
            this.getQuotes(true);
          })
        }
      });
  }

  download(quote: any) {
    this._QuotesService.download(quote);
    setTimeout(() => {
    }, 2000);
  }

  sendEmail(quote: any) {

    if (quote.client.emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar el presupuesto a la siguiente dirección? " + quote.client.emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._QuotesService.sendEmail(quote._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this.alertService.warn("El cliente no tiene un email cargado");
    }


  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getQuotes(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];
  
      // Verificar si todos los elementos están seleccionados
      const allSelected = this.quotes.every((quote: IQuote) => {
        const id = quote._id || '';
        return this.selection[id];
      });
  
      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };
  
      // Aplicar el nuevo estado a todos los elementos
      this.quotes.forEach((quote: IQuote) => {
        const id = quote._id || '';
        this.selection[id] = newValue;
      });
    }
  
    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
  

  openNewTaskModal() {
    const status: string = 'QUOTED';
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks'], { queryParams: { status: status, tp: new Date().getTime() } });
  }

  setAcceptedQuote(quote: IQuote) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Aceptar Presupuesto",
      message: "¿Desea aceptar este Presupuesto?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._QuotesService.updateQuote({ _id: quote._id, status: "ACCEPTED" }).subscribe((quote: IQuote) => {
            this._broadcaster.broadcast('OnQuoteChange', true);
            if (quote) this.getQuotes(true);
          });
        }
      });
  }

  scheduleTask(quote: any) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Programar Presupuesto",
      message: "¿Está seguro de que desea programar este Presupuesto?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let config = new MatDialogConfig();
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          const newTask = {
            status: "QUOTED",
            client: quote.client,
            company: quote.company,
            products: _.cloneDeep(quote.details),
            quote: quote._id,
            project: quote?.project
          }
          self.taskDialogRef = this._dialog.open(TaskModalComponent, config);
          self.taskDialogRef.componentInstance.task = _.cloneDeep(newTask);
          self.taskDialogRef.componentInstance.readOnly = false;
          self.taskDialogRef.componentInstance.scheduling = true;

          self.taskDialogRef.afterClosed().subscribe(async (task: any) => {
            if (task) {
              this._QuotesService.updateQuote({ _id: quote._id, status: "SCHEDULED" }).subscribe((quote: IQuote) => {
                this._broadcaster.broadcast('OnQuoteChange', true);
              });
            } else {
              this._broadcaster.broadcast('OnQuoteChange', true);
              this._broadcaster.broadcast('OnTaskChange', true);
            }

            if (task) {
              this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list'])
            } else {
              this.getQuotes()
            }
          });
        }
      });
  }
}